import type { ReactElement } from 'react';

export const PacketDetailPlaceholder = (): ReactElement => (
  <div className='relative mx-5 pb-5'>
    <div>&nbsp;</div>
    <div className='h-lgu-1' />
  </div>
);
